module.exports = __webpack_public_path__ + "img/MF.55df0a2e.svg";